import { TypedDocumentNode, gql } from '@apollo/client';

import useMutation from '@sorare/core/src/hooks/graphql/useMutation';

import {
  DeclareManagerProgressionTaskMutation,
  DeclareManagerProgressionTaskMutationVariables,
} from './__generated__/useDeclareManagerProgressionTask.graphql';

const DECLARE_MANAGER_PROGRESSION_TASK_MUTATION = gql`
  mutation DeclareManagerProgressionTaskMutation(
    $categoryName: ManagerProgressionCategorySlug!
    $name: ManagerProgressionTaskSlug!
    $sport: Sport!
  ) {
    declareManagerProgressionTask(input: { name: $name, sport: $sport }) {
      currentUser {
        id
        slug
        managerProgression(sport: $sport) {
          id
          categories(names: [$categoryName]) {
            id
            name
            badgeUrl
            categoryTasks {
              ... on ManagerTaskInterface {
                id
                name
                aasmState
                completedAt
                claimedAt
              }
            }
          }
        }
      }
      errors {
        message
        code
      }
    }
  }
` as TypedDocumentNode<
  DeclareManagerProgressionTaskMutation,
  DeclareManagerProgressionTaskMutationVariables
>;

export const useDeclareManagerProgressionTask = () => {
  return useMutation(DECLARE_MANAGER_PROGRESSION_TASK_MUTATION);
};
